import * as React from 'react';
import PageMain from '../../components/Navigation/PageMain/PageMain';
import CalendarSettings from '../../components/Settings/CalendarSettings/CalendarSettings';
import useAsyncRequestGeneralSettings from '../../hooks/useAsyncRequestGeneralSettings';
import { RequestStatus } from '../../sic-lib/enums/RequestStatus';
import { TimeZoneSettings } from '../../sic-lib/types/GeneralSettings';

export default function CalendarSettingsPage() {
    const [calendarSettings, setCalendarSettings] = React.useState<[TimeZoneSettings]>([
        {
            name: '',
            value: '',
            isAdmin: false,
            default: '',
            options: [],
        },
    ]);

    const { requestStatus, asyncRequestGeneralSettings } = useAsyncRequestGeneralSettings();

    React.useEffect(() => {
        async function request() {
            const asyncResult = await asyncRequestGeneralSettings({
                names: ['timezoneid'],
            });

            if (asyncResult) {
                setCalendarSettings(asyncResult);
            }
        }

        request();
    }, []);

    return (
        <PageMain
            pageTitle="Calendar Settings"
            showError={requestStatus === RequestStatus.error}
            showLoading={requestStatus !== RequestStatus.success}
        >
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <CalendarSettings timeZone={calendarSettings} />
                </div>
            </div>
        </PageMain>
    );
}
